// usage segments
const SPRINT = 'sprint';
const MILD = 'mild';
const REGULAR = 'regular';
const CHILLED = 'chilled';
const ALLERT = 'allert';
// 1. sourcing
const CC = 'CC';
const COMP_HNB = 'COMP_HNB';
const EVAPE_DUAL = 'EVAPE_DUAL';
const POLY_HNB = 'POLY_HNB';
// 2. motivation
const HIGH = 'HIGH';
const MID = 'MID';
const LOW = 'LOW';
// 3. reasoning
const SOCIAL = 'SOCIAL';
const TASTE = 'TASTE';
const AESTHETIC = 'AESTHETIC';

const DEFAULT = SPRINT;

const userSegmentTypes = {
    SPRINT,
    MILD,
    REGULAR,
    CHILLED,
    ALLERT,
    CC,
    COMP_HNB,
    EVAPE_DUAL,
    POLY_HNB,
    HIGH,
    MID,
    LOW,
    SOCIAL,
    TASTE,
    AESTHETIC,
    DEFAULT,
};

export default userSegmentTypes;
